import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-XK-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 31.85 54.01"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-XK-logo_svg__cls-1{fill:#0079b3}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M1.75 22.25C.91 23.6-.97 25.42.62 26.39c1.31.03 2.23.33 2.2 1.3-.03 1.13-1.28 1.18-1.45 1.89-.24.98 1.24 1.1 1.6 1.81-.08.65-1.22.85-1.03 1.91.38.41.8.3 1.08.58.97.92-.49 2.13-.61 2.98-.23 1.57 2.41 3.17 4.36 3.16 4.46-.02 9.84-2.71 14.46.08-1.71.38-5.85-.21-6.01 2.43-.05.77.92 1.7 1.34 2.4 1.65 2.64 2.96 5.85 3.29 9.08 2.73-10.04 5.17-21.32 7.77-31.87-5.11-2.23-8.83-5.63-14.87-7.37-2.56-.74-5.5-.98-7.7-.67.02 1.08-.68 1.36-.72 2.11-.04.91 1.46 1.41 2.21 1.94.97.67 1.49 1.41 1.64 2.32-.73-.28-.57-.95-1.7-.99-.31-.01-.84.3-1.41.34-.41.04-1.16-.7-1.37-.65-.71.16-1.53 2.41-1.95 3.07M8.94 4.17c-.42.59-.75 1.29-1.11 1.96 1.19.15 2.7.28 4.05.55 7.65 1.56 10.63 7.34 17.09 9.59.95-3.12 1.83-7.55 2.65-10.82.23-.9.41-1.47-.05-2.13-.95-.8-2.7-.46-3.48-1.28-.45-.48-.07-1-.6-1.18-1.82-.61-3.66.46-4.84-.86-.72.59-2.28.27-3.46.35-.79.05-1.52 1.12-2.12-.01-1.54.22-2.28 1.96-3.86 1.96-.32 0-.65-.29-1-.28-1.24.03-1.55 2.08-2.63 2.49-.42.04-.3-.51-.64-.34",
      class: "svg-XK-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M12.87 39.16s.5-.33 3.16-.37c3.54-.06 5.21 1.31 5.21 1.31-.17.09-.83.15-2.18.25-1.38.1-2.46.45-2.46.45-1.76.73-1.26 2.31-1.26 2.31-1.49-2.07-2.48-3.94-2.48-3.94",
      style: {"fill":"#004b86"}
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "XK-logo"}) } }